(function () {
	var sections = document.querySelectorAll(".spa-grooming-form");

	function updateFieldState(fieldControl) {
		var field = fieldControl.closest(".spa-grooming-form__field");

		if (!field) {
			return;
		}

		if (fieldControl.value && fieldControl.value.trim() !== "") {
			field.classList.add("has-focus-or-value");
		} else {
			field.classList.remove("has-focus-or-value");
		}
	}

	function formatPhoneNumber(value) {
		var digits = value.replace(/\D/g, "").slice(0, 10);
		var areaCode = digits.slice(0, 3);
		var prefix = digits.slice(3, 6);
		var lineNumber = digits.slice(6, 10);

		if (digits.length > 6) {
			return "(" + areaCode + ")-" + prefix + "-" + lineNumber;
		}

		if (digits.length > 3) {
			return "(" + areaCode + ")-" + prefix;
		}

		if (digits.length > 0) {
			return "(" + areaCode;
		}

		return "";
	}

	function getFieldContainer(fieldControl) {
		return fieldControl.closest(".spa-grooming-form__field") || fieldControl.closest(".spa-grooming-form__checkbox-row");
	}

	function getFieldErrorId(fieldControl) {
		return "spa-grooming-form-error-" + fieldControl.name.replace(/\W/g, "-");
	}

	function getFieldErrorElement(fieldControl) {
		var container = getFieldContainer(fieldControl);
		var error = document.getElementById(getFieldErrorId(fieldControl));

		if (!error && container) {
			error = document.createElement("p");
			error.className = "spa-grooming-form__error";
			error.id = getFieldErrorId(fieldControl);
			error.hidden = true;
			container.insertAdjacentElement("afterend", error);
		}

		return error;
	}

	function clearFieldError(fieldControl) {
		var container = getFieldContainer(fieldControl);
		var error = document.getElementById(getFieldErrorId(fieldControl));

		fieldControl.removeAttribute("aria-invalid");
		fieldControl.removeAttribute("aria-describedby");

		if (container) {
			container.classList.remove("has-error");
		}

		if (error) {
			error.textContent = "";
			error.hidden = true;
		}
	}

	function showFieldError(fieldControl, message) {
		var container = getFieldContainer(fieldControl);
		var error = getFieldErrorElement(fieldControl);

		fieldControl.setAttribute("aria-invalid", "true");
		fieldControl.setAttribute("aria-describedby", getFieldErrorId(fieldControl));

		if (container) {
			container.classList.add("has-error");
		}

		if (error) {
			error.textContent = message;
			error.hidden = false;
		}
	}

	function getFieldError(fieldControl) {
		var value = fieldControl.value ? fieldControl.value.trim() : "";

		if (fieldControl.required && fieldControl.type === "checkbox" && !fieldControl.checked) {
			if (fieldControl.name === "meets_health_requirements") {
				return "Please confirm your dog meets the health requirements.";
			}

			return "Please agree that Dogtopia can contact you.";
		}

		if (fieldControl.required && value === "") {
			if (fieldControl.name === "first_name") {
				return "Please enter your first name.";
			}

			if (fieldControl.name === "last_name") {
				return "Please enter your last name.";
			}

			if (fieldControl.name === "email") {
				return "Please enter a valid email address.";
			}

			if (fieldControl.name === "phone") {
				return "Please enter a valid phone number.";
			}
		}

		if (fieldControl.name === "email" && value !== "" && !fieldControl.checkValidity()) {
			return "Please enter a valid email address.";
		}

		if (fieldControl.name === "phone" && value !== "" && !/^\([0-9]{3}\)-[0-9]{3}-[0-9]{4}$/.test(value)) {
			return "Please enter a valid phone number.";
		}

		return "";
	}

	function validateForm(form) {
		var fields = form.querySelectorAll("input, select, textarea");
		var errors = {};

		fields.forEach(function (fieldControl) {
			var message = getFieldError(fieldControl);

			clearFieldError(fieldControl);

			if (message) {
				errors[fieldControl.name] = message;
				showFieldError(fieldControl, message);
			}
		});

		return errors;
	}

	function renderServerErrors(form, errors) {
		var firstInvalidField = null;

		Object.keys(errors || {}).forEach(function (fieldName) {
			var fieldControl = form.querySelector("[name='" + fieldName + "']");

			if (!fieldControl) {
				return;
			}

			showFieldError(fieldControl, errors[fieldName]);

			if (!firstInvalidField) {
				firstInvalidField = fieldControl;
			}
		});

		if (firstInvalidField) {
			firstInvalidField.focus();
		}
	}

	function setSubmittingState(form, isSubmitting) {
		var submitButton = form.querySelector(".spa-grooming-form__submit");

		form.classList.toggle("is-submitting", isSubmitting);
		setLoaderState(form, isSubmitting);

		if (!submitButton) {
			return;
		}

		submitButton.disabled = isSubmitting;

		if (isSubmitting) {
			submitButton.classList.add("is-submitting");
			submitButton.setAttribute("aria-busy", "true");
		} else {
			submitButton.classList.remove("is-submitting");
			submitButton.removeAttribute("aria-busy");
		}
	}

	function setLoaderState(form, isActive) {
		var loader = form.querySelector(".spa-grooming-form__loader");

		if (!loader) {
			return;
		}

		loader.classList.toggle("is-active", isActive);
		loader.setAttribute("aria-hidden", String(!isActive));
		loader.style.display = isActive ? "block" : "";
	}

	function getNoticeElement(form) {
		var notice = form.querySelector(".spa-grooming-form__notice");
		var actions = form.querySelector(".spa-grooming-form__actions");

		if (!notice) {
			notice = document.createElement("div");
			notice.className = "spa-grooming-form__notice";
			notice.setAttribute("role", "alert");
			notice.hidden = true;

			if (actions) {
				actions.appendChild(notice);
			} else {
				form.appendChild(notice);
			}
		}

		return notice;
	}

	function renderNotice(form, status, message) {
		var notice = getNoticeElement(form);

		notice.classList.remove("is-success", "is-error");
		notice.classList.add(status === "success" ? "is-success" : "is-error");
		notice.textContent = message;
		notice.hidden = false;
	}

	function clearNotice(form) {
		var notice = form.querySelector(".spa-grooming-form__notice");

		if (!notice) {
			return;
		}

		notice.classList.remove("is-success", "is-error");
		notice.textContent = "";
		notice.hidden = true;
	}

	function renderThankYou(form, message) {
		var section = form.closest(".spa-grooming-form");
		var title = section ? section.querySelector(".spa-grooming-form__title") : null;
		var intro = section ? section.querySelector(".spa-grooming-form__intro") : null;
		var thankYou = document.createElement("div");
		var thankYouTitleText = "Thanks! We received your grooming request.";
		var thankYouMessage = message || "Thank you for your submission.";
		var thankYouTitle = document.createElement("strong");
		var thankYouCopy = document.createElement("p");
		var thankYouCopyText = "";

		thankYou.className = "spa-grooming-form__thank-you";
		thankYou.setAttribute("role", "status");
		thankYou.setAttribute("tabindex", "-1");

		if (thankYouMessage.indexOf(thankYouTitleText) === 0) {
			thankYouCopyText = thankYouMessage.replace(thankYouTitleText, "").trim();
			thankYouTitle.textContent = thankYouTitleText;
			thankYou.appendChild(thankYouTitle);

			if (thankYouCopyText) {
				thankYouCopy.textContent = thankYouCopyText;
				thankYou.appendChild(thankYouCopy);
			}
		} else {
			thankYou.textContent = thankYouMessage;
		}

		if (title) {
			title.remove();
		}

		if (intro) {
			intro.remove();
		}

		form.replaceWith(thankYou);
		thankYou.focus();
	}

	sections.forEach(function (section) {
		var form = section.querySelector(".spa-grooming-form__fields");
		var fieldControls = section.querySelectorAll(".spa-grooming-form__field input, .spa-grooming-form__field select, .spa-grooming-form__field textarea");
		var checkboxControls = section.querySelectorAll(".spa-grooming-form__checkbox");
			var servicesToggle = section.querySelector(".spa-grooming-form__services-toggle");
			var servicesDetails = section.querySelector("#spa-services-details");
			var requirementsTrigger = section.querySelector(".spa-grooming-form__requirements-trigger");
			var requirementsPanel = section.querySelector("#spa-requirements-tooltip");

		fieldControls.forEach(function (fieldControl) {
			updateFieldState(fieldControl);

			fieldControl.addEventListener("focus", function () {
				var field = fieldControl.closest(".spa-grooming-form__field");

				if (field) {
					field.classList.add("is-focused");
				}
			});

			fieldControl.addEventListener("blur", function () {
				var field = fieldControl.closest(".spa-grooming-form__field");

				if (field) {
					field.classList.remove("is-focused");
				}

				updateFieldState(fieldControl);
			});

			fieldControl.addEventListener("input", function () {
				updateFieldState(fieldControl);
				clearFieldError(fieldControl);
			});

			fieldControl.addEventListener("change", function () {
				updateFieldState(fieldControl);
				clearFieldError(fieldControl);
			});
		});

		checkboxControls.forEach(function (fieldControl) {
			fieldControl.addEventListener("change", function () {
				clearFieldError(fieldControl);
			});
		});

		var phoneField = section.querySelector("#spa-phone");

		if (phoneField) {
			phoneField.addEventListener("input", function () {
				phoneField.value = formatPhoneNumber(phoneField.value);
				updateFieldState(phoneField);
			});

			phoneField.addEventListener("paste", function () {
				window.setTimeout(function () {
					phoneField.value = formatPhoneNumber(phoneField.value);
					updateFieldState(phoneField);
				}, 0);
			});
		}

		if (servicesToggle && servicesDetails) {
			servicesToggle.addEventListener("click", function () {
				var isExpanded = servicesToggle.getAttribute("aria-expanded") === "true";
				servicesToggle.setAttribute("aria-expanded", String(!isExpanded));
				servicesDetails.hidden = isExpanded;

				if (!isExpanded) {
					servicesDetails.focus();
				}
			});
		}

			if (requirementsTrigger && requirementsPanel) {
				requirementsTrigger.addEventListener("click", function (event) {
					var isExpanded = requirementsTrigger.getAttribute("aria-expanded") === "true";
					requirementsTrigger.setAttribute("aria-expanded", String(!isExpanded));
					requirementsPanel.hidden = isExpanded;
				});
			}

		if (form) {
			form.addEventListener("submit", function (event) {
				var ajaxEndpoint = form.getAttribute("action");
				var formData;
				var errors;
				var firstInvalidField;

				event.preventDefault();

				if (!ajaxEndpoint) {
					return;
				}

				setSubmittingState(form, true);
				clearNotice(form);
				errors = validateForm(form);

				if (Object.keys(errors).length > 0) {
					firstInvalidField = form.querySelector("[aria-invalid='true']");
					setSubmittingState(form, false);
					renderNotice(form, "error", "Please correct the highlighted fields.");

					if (firstInvalidField) {
						firstInvalidField.focus();
					}

					return;
				}

				formData = new FormData(form);
				formData.set("action", "dogtopia_spa_grooming_form_submit_ajax");

				fetch(ajaxEndpoint, {
					method: "POST",
					body: formData,
					credentials: "same-origin"
				})
				.then(function (response) {
					return response.json().catch(function () {
						return {
							success: false,
							data: {
								status: "error",
								message: "Submission failed (Error AJAX-" + response.status + "): The server returned a response that could not be read. Possible reason: The request did not reach the spa grooming form handler or another server error occurred.",
								errors: {}
							}
						};
					});
				})
				.then(function (payload) {
					var data = payload.data || {};
					var message = data.message || (payload.success ? "Thank you for your submission." : "Submission failed (Error AJAX-0): No error details were returned. Possible reason: The request failed before the API response could be read.");

					if (payload.success) {
						renderThankYou(form, message);
						return;
					}

					renderNotice(form, "error", message);
					renderServerErrors(form, data.errors || {});
				})
				.catch(function (error) {
					renderNotice(form, "error", "Submission failed (Error AJAX-FETCH): " + error.message + " Possible reason: The browser could not complete the request to the form handler.");
				})
				.finally(function () {
					if (document.body.contains(form)) {
						setSubmittingState(form, false);
					}
				});
			});
		}
	});
})();
